// tslint:disable: completed-docs
import {
    connect, injectReducer,
    injectSaga,
} from '@vfde-sails/core';
import { eventHelper } from './helpers/overlayHelper';
import { renderMockCMSContent } from './helpers/renderMockCMSContent';
import { triggerOverlay } from './action';
import { getQueryParam } from '@vfde-sails/utils';
import {
    ADDITIONAL_CMS_OPTIONS_FROM_DOM,
    CONTAINER_ACCORDION_GIGAKOMBI_BENEFITS_INFO,
    CONTAINER_ACCORDION_GIGAKOMBI_GENERAL_INFO,
    CONTAINER_STORAGE,
    DEFAULT_NOTIFICATION_CONTAINER, JSON_FILE_PARAM_NAME, JSON_FILE_PATH, MULTI_PICKER_HAS_CONTAINER,
    MULTI_PICKER_WANTS_CONTAINER,
} from 'Constant';
import {
    notificationHotlineLinkClick, offerGetsVisible, preSelectMultipickerSuccess, selectMultiPicker,
    setDefaultState, toggleFaqAccordion,
} from 'Container/Landingpage/action';
import { mountAccordionStatic } from 'Container/Landingpage/helpers/components/accordionHelper';
import {
    mountSelectOfferButton,
    updateOfferButton,
} from 'Container/Landingpage/helpers/components/buttonHelper';
import { mountLoadingSpinner } from 'Container/Landingpage/helpers/components/loadingSpinnerHelper';
import {
    adjustMultipickerHas,
    mountMultiPicker,
} from 'Container/Landingpage/helpers/components/multipickerHelper';
import {
    mountDefaultNotification,
    updateNotification,
} from 'Container/Landingpage/helpers/components/notificationHelper';
import { handleErrors } from 'Container/Landingpage/helpers/errorHandleHelper';
import { preselectMultipickerOnLoad } from 'Container/Landingpage/helpers/multipickerHelper';
import landingpageReducer from 'Container/Landingpage/reducer';
import landingpageSaga from 'Container/Landingpage/saga';
import {
    selectDefaultNotificationIsDisplayed,
    selectError,
    selectErrorMessage, selectLoading, selectRecentlyClickedOption, selectUserHasInternet,
    selectUserHasMobilfunk,
    selectUserHasNone,
    selectUserHasTV,
    selectUserWantsInternet,
    selectUserWantsMobilfunk,
    selectUserWantsRedplus,
    selectUserWantsTV,
} from 'Container/Landingpage/selector';
import { OFFER_DISPLAY_STORE } from 'Container/OfferDisplay/constant';
import { handleNotificationLinkClickEvent } from 'Container/OfferDisplay/helpers/eventHelper';
import offerDisplay from 'Container/OfferDisplay';
import Overlay from 'Container/Overlay';
import { createInitialStorage } from 'Container/Storage';
import storageSaga from 'Container/Storage/saga';
import tracking from 'Container/Tracking';
import { createStructuredSelector } from 'reselect';
import HTMLMarkUp from '../../index-mocked.html';
import {
    getAdditionalContents,
    getOffers,
} from './action';
import {
    LANDINGPAGE_STORE,
} from './constant';
import adobeTargetingHelper from './helpers/adobeTargetingHelper';
import { RootState } from './types';

interface StateProps {
    error: boolean;
    errorMessage: boolean;
    loading: boolean;
    has_mobilfunk: boolean;
    has_internet: boolean;
    has_tv: boolean;
    has_none: boolean;
    wants_mobilfunk: boolean;
    wants_internet: boolean;
    wants_tv: boolean;
    wants_redplus: boolean;
    default_notification_is_displayed: boolean;
    last_clicked_option: boolean;
}

/**
 * Landingpage function
 */
function LandingPage (state, action) {

    injectReducer(LANDINGPAGE_STORE, landingpageReducer);
    injectSaga(LANDINGPAGE_STORE, landingpageSaga);
    injectSaga(CONTAINER_STORAGE, storageSaga);

    action.createInitialStorage();
    action.setDefaultState(ADDITIONAL_CMS_OPTIONS_FROM_DOM);

    // Loading offer display container
    offerDisplay();

    renderMockCMSContent(HTMLMarkUp);

    const elLoadingSpinner = mountLoadingSpinner();

    /**
     * Loading offers in own container
     */
    let jsonUrl: string;
    const jsonFileFromQuery = getQueryParam(JSON_FILE_PARAM_NAME);

    if (jsonFileFromQuery) {
        jsonUrl = JSON_FILE_PATH + jsonFileFromQuery;
    } else {
        jsonUrl = ADDITIONAL_CMS_OPTIONS_FROM_DOM.offer_json_url;
    }

    /**
     * Loads Offers from JSON
     */
    action.getOffers(jsonUrl);

    /**
     * Loads additional contents from JSON
     */
    action.getAdditionalContents();

    // attach adobe target method to Offer-Handling
    adobeTargetingHelper(action);

    /**
     * Loading Overlay container
     */
    Overlay();

    /**
     * Accordions
     */
    mountAccordionStatic(CONTAINER_ACCORDION_GIGAKOMBI_GENERAL_INFO, action.toggleFaqAccordion);
    mountAccordionStatic(CONTAINER_ACCORDION_GIGAKOMBI_BENEFITS_INFO, action.toggleFaqAccordion);

    /**
     * CTA "Zeige mir die Angebote"
     */
    const buttonComponent = mountSelectOfferButton();

    /**
     * Notification, if user sis displayed the default offer given by CMS
     */
    const elNotification = mountDefaultNotification(DEFAULT_NOTIFICATION_CONTAINER);

    const multiPickerHas = mountMultiPicker(action.selectMultiPicker, MULTI_PICKER_HAS_CONTAINER);
    const multiPickerWants = mountMultiPicker(action.selectMultiPicker, MULTI_PICKER_WANTS_CONTAINER);

    // preSelect Pultipicker depending on URL Param or Session Storage
    const preSelectval = preselectMultipickerOnLoad(multiPickerHas, multiPickerWants);
    if (null !== preSelectval) {
        // if Option Tab is preselected, synch preselection to store
        action.preSelectMultipickerSuccess(preSelectval);
    }

    return {

        /**
         * This function is called on first load and everytime the store changes.
         * @param newState
         * @param oldState - You may also pass the oldState here, if needed
         */
        getDerivedStateFromProps (newState, oldState) {

            // loading is finished
            if (true === oldState.loading && false === newState.loading) {

                // hide loading spinner
                elLoadingSpinner.hide();

                /**
                 * initialize tracking container
                 */
                tracking();

            }

            // an Error appeared
            if (true === newState.error) {
                // displays pink overlay in CMS preview or error div online
                handleErrors(newState);
            }

            // only when we're in the "middle", where user klicks on any CTA or Button
            if (false === oldState.loading && false === newState.loading) {
                // when user click "has nothing", all others should be deselected. and vice versa
                adjustMultipickerHas(multiPickerHas, newState);
            }

            // initialize Overlay Clicks
            eventHelper(action.triggerOverlay);

            // upodate CTA based on Multipicker Selection
            updateOfferButton(buttonComponent, newState);

            // perhaps show notification
            updateNotification(elNotification, newState);
            handleNotificationLinkClickEvent(action.notificationHotlineLinkClick);

        },
    };
}

const mapStateToProps = createStructuredSelector<RootState, StateProps>({
    error: selectError(),
    errorMessage: selectErrorMessage(),
    loading: selectLoading(),
    has_mobilfunk: selectUserHasMobilfunk(),
    has_internet: selectUserHasInternet(),
    has_tv: selectUserHasTV(),
    has_none: selectUserHasNone(),
    wants_mobilfunk: selectUserWantsMobilfunk(),
    wants_internet: selectUserWantsInternet(),
    wants_tv: selectUserWantsTV(),
    wants_redplus: selectUserWantsRedplus(),
    default_notification_is_displayed: selectDefaultNotificationIsDisplayed(),
    last_clicked_option: selectRecentlyClickedOption(),
});

const mapDispatch = {
    setDefaultState,
    selectMultiPicker,
    offerGetsVisible,
    notificationHotlineLinkClick,
    createInitialStorage,
    preSelectMultipickerSuccess,
    triggerOverlay,
    toggleFaqAccordion,
    getOffers,
    getAdditionalContents,
};

const landingPage = connect(mapStateToProps, mapDispatch)(LandingPage);
export default landingPage;
